export default __webpack_public_path__ + "static/media/inspect-exterior-logo.1ac817f0.gif";